var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34868 2.51531C6.81359 2.0504 7.56736 2.0504 8.03227 2.51531L15.1751 9.65817C15.64 10.1231 15.64 10.8768 15.1751 11.3418L8.03227 18.4846C7.56736 18.9495 6.81359 18.9495 6.34868 18.4846C5.88377 18.0197 5.88377 17.2659 6.34868 16.801L12.6497 10.5L6.34868 4.1989C5.88377 3.73399 5.88377 2.98022 6.34868 2.51531Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrGray);
export default __webpack_public_path__ + "static/media/right_arr_gray.e233ab86e50c83b0cfc38aa49917f5c2.svg";
export { ForwardRef as ReactComponent };